// extracted by mini-css-extract-plugin
export default {"card":"HZ-z","carouselContainer":"IZ-z","carouselContent":"JZ-z"};